import { useGlobalValue } from "../../state/GlobalProvider";
import { checkRoles } from "../../utils/roleValidator";
const CheckPermission = props => {
  const {
    roles = [],
    extraValidation
  } = props;
  const {
    user
  } = useGlobalValue();
  const hasPermission = checkRoles(user, roles);
  if (roles.length && typeof extraValidation !== "undefined") {
    return hasPermission && extraValidation ? props.children : false;
  }
  if (roles.length) {
    return hasPermission ? props.children : false;
  }
  if (typeof extraValidation !== null) {
    return extraValidation ? props.children : false;
  }
  return false;
};
export default CheckPermission;